import { render, staticRenderFns } from "./insight.vue?vue&type=template&id=0ddd231e"
import script from "./insight.vue?vue&type=script&lang=js"
export * from "./insight.vue?vue&type=script&lang=js"
import style0 from "./insight.vue?vue&type=style&index=0&id=0ddd231e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports